import styled, {css} from 'styled-components';

import type {Size} from './types';

import {getColor, ms, square} from '../../styles';

const sizeScheme: Record<Size, number> = {
  l: 24,
  m: 20,
  s: 16,
  xl: 32,
  xs: 14,
};

export const Icon = styled(({color: _, component, size: __, ...rest}) => {
  const Component = component;

  return <Component {...rest} />;
}).attrs(p => ({
  fill: getColor(p.color)(p),
}))<{withMargin: boolean}>`
  ${p =>
    p.withMargin &&
    css`
      margin-inline-end: ${ms(10)};
    `};

  ${p => {
    switch (p.size) {
      case 'l':
        return css`
          ${square(sizeScheme.l)};
        `;
      case 'm':
        return css`
          ${square(sizeScheme.m)};
        `;
      case 's':
        return css`
          ${square(sizeScheme.s)};
        `;
      case 'xl':
        return css`
          ${square(sizeScheme.xl)};
        `;
      case 'xs':
        return css`
          ${square(sizeScheme.xs)};
        `;
    }
  }}
`;
